// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"199":"1daf700b","295":"69979381","460":"716e681a","680":"b8bc0f8e","896":"9b242f87","929":"de45ce2c"}[chunkId] + ".css";
};